import * as React from 'react';
import Box from '@mui/material/Box';
import { GridRenderCellParams, GridRowId } from '@mui/x-data-grid';
import Rating from '@mui/material/Rating';

interface RatingValueProps {
  name: string;
  value: number;
}

export const RatingValue = ({ name, value }: RatingValueProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        lineHeight: '24px',
        color: 'text.secondary',
      }}
    >
      <Rating
        precision={0.5}
        name={name}
        value={value}
        sx={{ mr: 1 }}
        readOnly
      />
    </Box>
  );
};

const MemoizedRatingValue = React.memo(RatingValue);

export function renderRating(
  params: GridRenderCellParams<number, { id: GridRowId }, any>
) {
  if (params.rowNode.isAutoGenerated || params.value == null) {
    return '';
  }
  return (
    <MemoizedRatingValue value={params.value} name={params.row.id.toString()} />
  );
}
